import type { FC } from "react";
import { optimizeImageUrl } from "~/lib/imageUtils";
import type { ProductSlide } from "~/lib/productSlides";
import { productImageSrc, withPosterFragment } from "~/lib/productSlides";
import { youtubeThumbnailUrl } from "~/lib/youtubeUtils";
import YoutubeIcon from "../icons/YoutubeIcon";
import PlayIcon from "../icons/PlayIcon";

/** Thumbnail content of one product slide: image, YouTube still or video file frame. */
const WvProductSlideThumbnail: FC<{ slide: ProductSlide }> = ({ slide }) => {
  if (slide.kind === "image") {
    return (
      <img
        className="product-viewport__img"
        src={optimizeImageUrl(productImageSrc(slide.image))}
        alt={slide.image.altText || ""}
        loading="lazy"
      />
    );
  }

  if (slide.kind === "youtube") {
    return (
      <>
        <img
          className="product-viewport__img object-cover"
          src={youtubeThumbnailUrl(slide.id, "mqdefault")}
          alt={slide.title}
          loading="lazy"
        />
        <YoutubeIcon className="position-absolute" />
      </>
    );
  }

  return (
    <>
      <video
        className="product-viewport__img object-cover"
        preload="metadata"
        muted
        playsInline
        tabIndex={-1}
        aria-hidden
        src={withPosterFragment(slide.src)}
      />
      <PlayIcon compact />
    </>
  );
};

export default WvProductSlideThumbnail;
